export function copyProperty<T>(arr: T[], propertyName: string, newPropertyName: string): T[] {
	if (!Array.isArray(arr)) {
		return [];
	}

	return arr.map(item => ({ ...item, [newPropertyName]: item[propertyName] }));
}
